import { ContactInquiryType } from './contact-form-schema'

export const contactInquiryQueryToFormValue: Record<string, ContactInquiryType> = {
  'architecture-discussion': ContactInquiryType.Architecture,
  'executive-briefing': ContactInquiryType.Executive,
  'solution-scale': ContactInquiryType.Solution,
  'solution-finance': ContactInquiryType.Solution,
  'solution-cmo': ContactInquiryType.Solution,
  'solution-multibrand': ContactInquiryType.Solution,
  'solution-consultation': ContactInquiryType.Solution,
  'partnership': ContactInquiryType.Partnership,
  'developer-access': ContactInquiryType.Developer,
}

export const contactInquiryQueryToIntentKey: Record<string, string> = {
  'executive-briefing': 'executiveBriefing',
  'architecture-discussion': 'architectureDiscussion',
  'solution-consultation': 'solutionConsultation',
  'solution-scale': 'solutionConsultation',
  'solution-finance': 'solutionConsultation',
  'solution-cmo': 'solutionConsultation',
  'solution-multibrand': 'solutionConsultation',
  'partnership': 'ecosystemPartnership',
  'developer-access': 'developerSandbox',
}
